import { BasicPageTitle } from "../../Theme/basicElements";
import OrdersFiltersModule from "./Modules/OrdersFiltersModule";
import OrdersStatusSelector from "./Modules/OrdersStatusSelector";
import OrdersTableModule from "./Modules/OrdersTableModule";
import { OrdersPageWrapper } from "./styled";

const MyOrdersPage = () => {
  return (
    <OrdersPageWrapper>
      <BasicPageTitle>My orders</BasicPageTitle>
      <OrdersFiltersModule />
      <OrdersStatusSelector />
      <OrdersTableModule />
    </OrdersPageWrapper>
  );
};

export default MyOrdersPage;
